import type { FunctionComponent } from "react";
import { CLASS_NAMES, TITLE } from "components/job/JobLayout/JobLineItems/constants";
import Footer from "components/job/JobLayout/JobLineItems/Footer";
import List from "components/job/JobLayout/JobLineItems/List";

export interface JobLineItemsProps {}

const JobLineItems: FunctionComponent<JobLineItemsProps> = function () {
  return (
    <div className={CLASS_NAMES.container}>
      <p className={CLASS_NAMES.title}>{TITLE}</p>
      <div className={CLASS_NAMES.content}>
        <List />
      </div>
      <div className={CLASS_NAMES.footer}>
        <Footer />
      </div>
    </div>
  );
};

export default JobLineItems;
